function htwRefreshOffers(){
 document.querySelectorAll('[data-htw-offer-end]').forEach(el=>{if(Date.now()>=Date.parse(el.dataset.htwOfferEnd))el.hidden=true;});
 document.querySelectorAll('[data-htw-price-form]').forEach(el=>{
  const form=document.getElementById(el.dataset.htwPriceForm);
  const id=form?.elements.namedItem('id')?.value;
  const data=el.querySelector('[data-htw-variant-prices]');
  const amount=el.querySelector('[data-htw-promo-amount]');
  if(!id||!data||!amount||el.dataset.htwCurrentVariant===id)return;
  try{const prices=JSON.parse(data.textContent);if(prices[id]){amount.textContent=prices[id];el.dataset.htwCurrentVariant=id;}}catch{}
 });
 document.querySelectorAll('[data-htw-countdown]').forEach(el=>{
  const seconds=Math.floor((Date.parse(el.getAttribute('expires-at'))-Date.now())/1000);
  if(!Number.isFinite(seconds)||seconds<=0){el.closest('.shopify-section').hidden=true;return;}
  const parts={days:Math.floor(seconds/86400),hours:Math.floor(seconds%86400/3600),minutes:Math.floor(seconds%3600/60),seconds:seconds%60};
  Object.entries(parts).forEach(([unit,value])=>{const node=el.querySelector('[data-unit="'+unit+'"]');if(node)node.textContent=String(value).padStart(2,'0');});
 });
}
htwRefreshOffers();setInterval(htwRefreshOffers,1000);document.addEventListener('shopify:section:load',htwRefreshOffers);
